<div
  class="section-card"
  [class.section-focused]="isActive"
  (click)="activate()">
  <!-- Purple header bar -->
  <div class="section-header">
    <span class="section-header-title">{{
      sectionTitle || "Untitled Section"
    }}</span>
    <span class="section-badge">
      Section {{ sectionIndex }}
      <i *ngIf="isConditional" class="bi bi-diagram-2-fill"></i>
    </span>
  </div>

  <!-- Card body -->
  <div class="section-body">
    <!-- FOCUSED: editable inputs -->
    <ng-container *ngIf="isActive">
      <input
        class="section-title-input"
        type="text"
        placeholder="Untitled Section"
        [(ngModel)]="sectionTitle"
        (ngModelChange)="onTitleChange($event)" />

      <textarea
        class="section-desc-input"
        placeholder="Enter a description"
        rows="2"
        [(ngModel)]="sectionDescription"
        (ngModelChange)="onDescriptionChange($event)"></textarea>

      <!-- Section Conditions (shown when conditional is on and not the first section) -->
      <ng-container *ngIf="isConditional && sectionIndex > 1">
        <div class="section-conditions mt-3">
          <p class="conditions-label fw-bold mb-1">Section Conditions</p>
          <p class="conditions-help text-muted small mb-2">
            Select an answer from the current section's questions in order for
            user to see this section.
          </p>
          <div class="d-flex gap-2 flex-wrap">
            <ng-select
              class="condition-select"
              placeholder="Select Question"
              [items]="conditionQuestions"
              bindLabel="question"
              bindValue="id"
              [clearable]="true"
              [searchable]="false"
              [(ngModel)]="selectedConditionQuestionId"
              (ngModelChange)="onConditionQuestionChange()">
              <ng-template ng-label-tmp let-item="item">
                <span [innerHTML]="item.question"></span>
              </ng-template>
              <ng-template ng-option-tmp let-item="item">
                <span [innerHTML]="item.question"></span>
              </ng-template>
            </ng-select>

            <ng-select
              class="condition-select"
              placeholder="Select answer"
              [items]="conditionAnswers"
              bindLabel="answer"
              bindValue="id"
              [clearable]="true"
              [searchable]="false"
              [disabled]="!selectedConditionQuestionId"
              [(ngModel)]="selectedConditionAnswerId"
              (ngModelChange)="onConditionAnswerChange()">
            </ng-select>
          </div>
        </div>
      </ng-container>

      <!-- Footer: conditional toggle + kebab (hidden for first section) -->
      <div class="section-footer" *ngIf="sectionIndex > 1">
        <ng-container *ngIf="formType !== ProFormType.QUIZ">
          <div class="d-flex align-items-center gap-2">
            <span class="small">Conditional</span>
            <button
              class="btn-reset form-switch"
              aria-label="Toggle conditional section">
              <input
                class="form-check-input cursor-pointer"
                type="checkbox"
                role="switch"
                [checked]="isConditional"
                (change)="toggleConditional()" />
            </button>
          </div>

          <div class="section-footer-divider"></div>
        </ng-container>

        <div ngbDropdown placement="bottom-end">
          <button
            class="btn-reset section-kebab-btn"
            ngbDropdownToggle
            aria-label="Section options">
            <i class="bi bi-three-dots-vertical fs-5"></i>
          </button>
          <div ngbDropdownMenu>
            <button ngbDropdownItem type="button" (click)="openDeleteModal()">
              Delete section
            </button>
            <button ngbDropdownItem type="button" (click)="requestReorder()">
              Reorder sections
            </button>
          </div>
        </div>
      </div>
    </ng-container>

    <!-- UNFOCUSED: read-only values -->
    <ng-container *ngIf="!isActive">
      <div class="section-desc-display" *ngIf="sectionDescription">
        {{ sectionDescription }}
      </div>
    </ng-container>
  </div>
</div>

<app-modal
  #deleteSectionModal
  [modalConfig]="{
    titleText: 'Delete Section',
    headerClass: ['modal-header', 'bg-primary', 'text-white'],
    windowClass: 'custom-class',
    customFooter: true,
  }">
  <button
    class="bg-transparent border-0"
    title="Close"
    aria-label="close"
    headerContent
    (click)="deleteSectionModal.close()">
    <i class="bi bi-x-lg text-white"></i>
  </button>
  <ng-container *ngIf="isConditional; else simpleDeleteBody">
    <p>
      Deleting a section also deletes the questions and may change how
      respondents move through the form if conditionals are associated with it.
      You can drag questions to other sections to preserve them.
    </p>
    <p>Are you sure you want to delete this section?</p>
  </ng-container>
  <ng-template #simpleDeleteBody>
    <p>
      Deleting a section also deletes all its questions. You can drag questions
      to other sections to preserve them.
    </p>
    <p>Are you sure you want to delete this section?</p>
  </ng-template>
  <div footerContent>
    <div class="d-flex justify-content-between">
      <button type="button" class="btn" (click)="deleteSectionModal.close()">
        Cancel
      </button>
      <button
        type="button"
        class="btn btn-md btn-primary"
        (click)="deleteSection()">
        Yes, delete section
      </button>
    </div>
  </div>
</app-modal>
